(() => {
  const selectors = {
    header: '.site-header'
  }

  window.setStyleVariables = () => {
    const header = document.querySelector(selectors.header);

    document.documentElement.style.setProperty('--header-height', `${header ? header.offsetHeight : 0}px`);
    $('#reamazejs-container').show();
  };

  setTimeout(() => { window.setStyleVariables()}, 1000);

  window.addEventListener('DOMContentLoaded', window.setStyleVariables);
  window.addEventListener('resize', window.setStyleVariables);
})();
